import axios from 'axios';

export default class BulkContentLoader {

  constructor(el) {

    this.loaded = false;
    this.container = el;
    this.idList = [];
    this.elements = {};
    this.replaceElement = '.bulk-content';
    this.url = this.container.getAttribute('data-bulk-content-url');
    this.container.querySelectorAll('div[data-movie-id]').forEach(element => {

      const id = parseInt(element.getAttribute('data-movie-id'));
      this.elements[id] = element;
      this.idList.push(id);
    });
    if (this.idList.length == 0) {

      return;
    }
    if (document.readyState == 'complete') {

      this.loadContent();
    } else {

      const loadContent = this.loadContent.bind(this);
      window.addEventListener('load', loadContent, false);
    }
  }

  loadContent() {

    if (this.loaded) {

      return;
    }

    axios.get(this.url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      params: {
        'id_list': JSON.stringify(this.idList)
      }
    })
    .then(res => {

      for (let i in res.data) {

        if (typeof res.data[i] != 'object') {

          this.elements[i].querySelector(this.replaceElement).innerHTML = res.data[i];
        } else if (res.data[i].content) {

          this.elements[i].querySelector(this.replaceElement).innerHTML = res.data[i].content;
          if (res.data[i].isFav) {

            const addTo = this.elements[i].querySelector('.tc-add-to');
            if (addTo && addTo.handler) {

              addTo.handler.setAddedState(res.data[i].isFav);
              addTo.handler.syncState();
            }
          }
        }
      }
    })
    .catch(error => {
      this.container.classList.add('has-error');

      throw `BulkContentLoader.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
    });
  }
};
